import { useAuthStore } from '../store/authStore.js';

// Qué incluye el plan del comercio, visto desde la caja.
//
// Las banderas llegan con el comercio al iniciar sesión (`tenant.planLimits`)
// y se refrescan al arrancar y al volver a primer plano. Esconder un botón no
// es un control —el servidor es quien manda—; esto solo evita ofrecer algo
// que el servidor va a rechazar.
//
// Una bandera que el servidor no menciona se da por incluida: quien inició
// sesión antes de que existieran, y los planes Omnicanal con punto de venta,
// las tienen todas. Solo un `false` explícito apaga la función.
export const planIncluye = (tenant, funcion) => tenant?.planLimits?.features?.[funcion] !== false;

const esGiroRestaurante = (tenant) => {
  const giro = tenant?.businessType ?? 'retail';
  return giro === 'restaurant' || giro === 'mixed';
};

// Servicio en mesa: mesas, comandas a cocina, comensales y tiempos. Son dos
// preguntas y hacen falta las dos: el giro dice si le aplica, el plan si lo
// paga. Una cafetería en plan Negocio cobra en mostrador, sin mesas.
export const servicioEnMesa = (tenant) => esGiroRestaurante(tenant) && planIncluye(tenant, 'hasRestaurant');

// Cocina: Marchar, tiempos, "en cocina" y la pantalla de cocina. Es un ajuste
// del negocio, no del plan: muchos restaurantes son una sola tablet que toma
// la orden y cobra, sin nadie que lea una comanda. Mesas, cuentas y comensales
// siguen igual. Solo un `false` explícito la apaga (quien inició sesión antes
// de que existiera el ajuste la sigue teniendo).
export const usaCocina = (tenant) => servicioEnMesa(tenant) && tenant?.posKitchenEnabled !== false;

// Lo mismo, para código que no es un componente (el armado del ticket).
export const planFactura = () => planIncluye(useAuthStore.getState().tenant, 'hasCfdi');

export const usarPlan = () => {
  const tenant = useAuthStore((s) => s.tenant);
  return {
    servicioEnMesa: servicioEnMesa(tenant),
    cocina:         usaCocina(tenant),
    // Modificadores y dividir la cuenta vienen con el servicio en mesa, pero
    // no dependen del giro: una tienda en un plan que los trae los conserva.
    modificadores:  planIncluye(tenant, 'hasRestaurant'),
    dividirCuenta:  planIncluye(tenant, 'hasRestaurant'),
    propinas:       planIncluye(tenant, 'hasTips'),
    cfdi:           planIncluye(tenant, 'hasCfdi'),
  };
};
